import { AudiencesIcon, Tabs } from '@innovationdepartment/proxima-ui';
import type { CreateSeedAudiencesModalViewProps, Tab } from 'types/audiences';
import ModalBase from 'ui/ModalBase';
import CategoryShoppers from './CategoryShoppers';
import COLAL from './COLALs';

const CreateSeedAudiencesModalView = (props: CreateSeedAudiencesModalViewProps) => {
  const { show, onClose, tab, tabs, onTabChange } = props;

  return (
    <ModalBase
      open={show}
      onClose={onClose}
      icon={<AudiencesIcon />}
      title="Generate new audiences"
      header={{
        padding: 'small',
        bottomContent: (
          <Tabs tabs={tabs} onChange={nextTab => onTabChange(nextTab as Tab)} tab={tab} />
        )
      }}
    >
      {tab === 'categoryShoppers' && <CategoryShoppers {...props} tab="categoryShoppers" />}
      {tab === 'colal' && <COLAL {...props} tab="colal" />}
    </ModalBase>
  );
};

export default CreateSeedAudiencesModalView;
